<template>
  <div class="phone-input-wrapper" :class="{ 'phone-input-wrapper-error': hasError }">
    <div class="phone-prefix-select" @click="$emit('toggle-dropdown')">
      {{ prefix }}
      <span class="arrow">
        <img
          :src="dropdownVisible ? upIcon : downIcon"
          alt=""
        />
      </span>
      <ul v-if="dropdownVisible" class="phone-prefix-options">
        <li
          v-for="item in prefixList"
          :key="item.code"
          @click.stop="$emit('select-prefix', item)"
          :class="{ active: '+' + item.code === prefix }"
        >
          +{{ item.code }}
        </li>
      </ul>
    </div>
    <div class="phone-divider"></div>
    <input
      class="phone-input"
      type="tel"
      inputmode="tel"
      :value="value"
      :placeholder="$t('home_partner_input_phone')"
      @input="onInput"
      @blur="onBlur"
      @mouseleave="$emit('mouseleave', $event)"
    />
  </div>
</template>

<script>
import downIcon from "@/assets/Keeta2/down.png";
import upIcon from "@/assets/Keeta2/up.png";

export default {
  name: "PhoneInput",
  data() {
    return {
      downIcon,
      upIcon,
    };
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "+852",
    },
    prefixList: {
      type: Array,
      default: () => [],
    },
    dropdownVisible: {
      type: Boolean,
      default: false,
    },
    clearTrigger: {
      type: [Number, String, Boolean],
      default: 0,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.value.trim();
      this.$emit("mobile", { mobile: value, regionCode: this.prefix });
    },
    onBlur(event) {
      const value = event.target.value.trim();
      this.$emit("blur", { mobile: value, regionCode: this.prefix });
    },
  },
  watch: {
    clearTrigger() {
      this.$nextTick(() => {
        const inputDiv = this.$el.querySelector(
          ".phone-input"
        );
        if (inputDiv) inputDiv.value = "";
      });
    },
  },
};
</script>

<style scoped lang="scss">
.phone-input-wrapper {
  box-sizing: border-box;
  width: 550px;
  height: 72px;
  display: flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 12px;
  position: relative;

  &.phone-input-wrapper-error {
    border: 0.5px solid #ff7700;
  }
}

.phone-prefix-select {
  padding: 0 10px 0 20px;
  display: flex;
  align-items: center;
  font-size: 22px;
  cursor: pointer;
  position: relative;

  .arrow {
    margin-left: 8px;
    display: inline-flex;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.phone-prefix-options {
  position: absolute;
  top: 110%;
  left: 0;
  width: 100px;
  border-radius: 12px;
  background: #FFFFFF;
  box-shadow: 0px 6.28px 18.84px 0px #00000019;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0;
  padding: 6px;
  list-style: none;
  z-index: 10;

  li {
    box-sizing: border-box;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 10px 12px 10px 12px;
    font-size: 22px;
    cursor: pointer;

    &:hover {
      border-radius: 8px;
      background: #1119250C;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: center;
    }
  }
}

.phone-divider {
  width: 1px;
  height: 35px;
  background: #eee;
  margin: 0 10px;
}

.phone-input {
  padding: 18px 10px;
  flex: 1;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
  border: none;
  background: transparent;
  font: inherit;
  color: inherit;

  &::placeholder {
    color: #999;
    opacity: 1;
  }

  &:focus,
  &:focus-visible {
    outline: none;
  }
}
</style>
